import { getAccessToken } from "../../services/authService"

// Loads every script of the signed-in user through the existing paginated /document endpoint.
export const loadUserScripts = async (isCancelled = () => false) => {
  const token = getAccessToken()
  if (!token) throw new Error("A valid session not found")
  const scripts = []
  let lastId = null
  while (!isCancelled()) {
    const response = await fetch(`${process.env.REACT_APP_DEV_API}/document?sort=recently_created&limit=100${lastId ? `&lastId=${encodeURIComponent(lastId)}` : ""}`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    })
    if (!response.ok) throw new Error("Could not load scripts")
    const body = await response.json()
    const page = Array.isArray(body.data) ? body.data : []
    scripts.push(...page)
    const nextId = page[page.length - 1]?._id
    if (page.length < 100 || !nextId || nextId === lastId) break
    lastId = nextId
  }
  return scripts
}
